import { render, staticRenderFns } from "./TelbtnEdit.vue?vue&type=template&id=b2ab615a"
import script from "./TelbtnEdit.vue?vue&type=script&lang=js"
export * from "./TelbtnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports